import { useCallback, useSyncExternalStore } from 'react';

import { useInlineEditsManager } from '../../contexts/InlineEditsManagerContext';
import { OpenedEdits } from '../../services/InlineEditsManager';

/**
 * Retrieves the current inline edits opened by InlineEditsManager, automatically refreshing when inline edits change.
 */
export function useOpenInlineEdits(): OpenedEdits | undefined {
  const manager = useInlineEditsManager();

  // When the manager emits 'changed', then re-read the opened edits.
  const subscribe = useCallback(
    (onStoreChange: () => void) => manager.on('changed', onStoreChange),
    [manager],
  );
  return useSyncExternalStore(subscribe, () => manager.openedEdits);
}
